// extracted by mini-css-extract-plugin
export var addViewLink = "_11-1";
export var availabilityIcon = "_11-16";
export var availabilitySelectionIcon = "_11-15";
export var backButton = "_11-2";
export var backIcon = "_11-z";
export var conversationCount = "_11-3";
export var dragHandle = "_11-5";
export var dropdown = "_11-e";
export var dropdownIcon = "_11-7";
export var dropdownOption = "_11-6";
export var dropdownTriangle = "_11-d";
export var expand = "_11-f";
export var folder = "_11-i";
export var folderItem = "_11-c";
export var icon = "_11-8";
export var iconRow = "_11-9";
export var image = "_11-a";
export var logo = "_11-b";
export var navContainer = "_11-h";
export var navigationFooter = "_11-g";
export var pageShell = "_11-0";
export var placeholderAvailable = "_11-11";
export var placeholderBox = "_11-14";
export var placeholderBusy = "_11-13";
export var placeholderUnavailable = "_11-12";
export var profile = "_11-k";
export var profileContainer = "_11-m";
export var profileDropdown = "_11-n";
export var profileImage = "_11-l";
export var profileMain = "_11-o";
export var profileSubtitle = "_11-q";
export var profileTitle = "_11-p";
export var reorderIcon = "_11-r";
export var sentLine = "_11-u";
export var settingsHeader = "_11-s";
export var sidenavTextColor = "_11-y";
export var spamLine = "_11-t";
export var subitemWithTag = "_11-4";
export var supportItems = "_11-j";
export var teamText = "_11-10";
export var viewLine = "_11-x";
export var viewLineButton = "_11-w";
export var viewLineButtons = "_11-v";